import { CanGraphMessages, TranslationCanGraphMessages } from "../interfaces/canGraphMessages";

const canGraphMessages: TranslationCanGraphMessages = {
  [CanGraphMessages.title]: "CAN Graph",
  [CanGraphMessages.vehicle]: "Vehicle",
  [CanGraphMessages.day]: "Day",
  [CanGraphMessages.apply]: "Apply",
  [CanGraphMessages.loading]: "Loading CAN bus data…",
  [CanGraphMessages.noDataTitle]: "Pick a vehicle and a day to view the CAN bus",
  [CanGraphMessages.noDataDescription]: "Only ST300STT commands are queried (sole source of CAN data). Cache is preferred; history is used as a fallback.",
  [CanGraphMessages.fields]: "Fields",
  [CanGraphMessages.fieldsCanGroup]: "CAN bus",
  [CanGraphMessages.fieldsTrackerGroup]: "Tracker comparison",
  [CanGraphMessages.selectAll]: "Select all",
  [CanGraphMessages.clearAll]: "Clear",
  [CanGraphMessages.zoomIn]: "Zoom in",
  [CanGraphMessages.zoomOut]: "Zoom out",
  [CanGraphMessages.resetZoom]: "Reset zoom",
  [CanGraphMessages.sourceLabel]: "Data source",
  [CanGraphMessages.sourceCache]: "Cache (reg_trackers_data_cache)",
  [CanGraphMessages.sourceData]: "History (reg_trackers_data)",
  [CanGraphMessages.sourceTooltipCache]: "Unprocessed data (every message from the last 10 days)",
  [CanGraphMessages.sourceTooltipData]: "Processed data (only \"important\" messages, no retention limit)",
  [CanGraphMessages.pointsCount]: "Points",
  [CanGraphMessages.devId]: "IMEI",
  [CanGraphMessages.invalidDateRange]: "Invalid range. Pick a single day.",
  [CanGraphMessages.vehicleWithoutHardware]: "Vehicle has no linked tracker.",
  [CanGraphMessages.success]: "CAN bus data loaded.",
  [CanGraphMessages.error]: "Failed to load CAN bus data.",
  [CanGraphMessages.fieldCanSpd]: "CAN Speed (km/h)",
  [CanGraphMessages.fieldCanEngineRpm]: "Engine RPM",
  [CanGraphMessages.fieldCanEngineCoolantTemperature]: "Coolant temp (°C)",
  [CanGraphMessages.fieldCanFuelLevelSmoothed]: "Fuel level",
  [CanGraphMessages.fieldCanFuelConsumption]: "Fuel consumption",
  [CanGraphMessages.fieldCanTotalFuelUsed]: "Total fuel used (L)",
  [CanGraphMessages.fieldCanTotalFuelUsedCounted]: "Total fuel used (counted) (L)",
  [CanGraphMessages.fieldCanTotalIdleFuelUsed]: "Idle fuel used (L)",
  [CanGraphMessages.fieldCanTotalEngineHours]: "Engine hours (h)",
  [CanGraphMessages.fieldCanTotalEngineHoursCounted]: "Engine hours (counted) (h)",
  [CanGraphMessages.fieldCanTotalDrivingTime]: "Total driving time (h)",
  [CanGraphMessages.fieldCanOdometer]: "CAN odometer (m)",
  [CanGraphMessages.fieldCanIgn]: "CAN ignition (0/1)",
  [CanGraphMessages.fieldCanGcvw]: "Gross combination weight (kg)",
  [CanGraphMessages.fieldSpd]: "GPS speed (km/h)",
  [CanGraphMessages.fieldDist]: "Tracker odometer (m)",
  [CanGraphMessages.fieldHMeter]: "Tracker hour meter (min)",
  [CanGraphMessages.fieldPwrVolt]: "Main voltage (V)"
};

export const messages = canGraphMessages;
